import React, { useEffect, useState, createElement } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChefHat, Check, X, ShoppingBag, Utensils, Droplet, CupSoda, ArrowRight, Star, ShieldCheck, Flame } from 'lucide-react';
export function SalesPage() {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  useEffect(() => {
    document.title = 'Sabor Callejero';
    // Defer Meta Pixel loading
    const loadPixel = () => {
      if (typeof window !== 'undefined' && !(window as any).fbq) {
        const f = window as any;
        const n = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = true;
        n.version = '2.0';
        n.queue = [];
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        document.head.appendChild(script);
        (window as any).fbq('init', '1375884300474449');
      }
      if ((window as any).fbq) {
        ;
        (window as any).fbq('track', 'PageView');
      }
    };
    // Load pixel after page is interactive
    if (document.readyState === 'complete') {
      setTimeout(loadPixel, 100);
    } else {
      window.addEventListener('load', () => setTimeout(loadPixel, 100));
    }
  }, []);
  const handleAddToCart = () => {
    if ((window as any).fbq) {
      ;
      (window as any).fbq('track', 'AddToCart', {
        content_name: 'Sabor Callejero - Menú Viral de Combos',
        content_type: 'product',
        value: 6.39,
        currency: 'USD'
      });
    }
  };
  const scrollToOffer = () => {
    document.getElementById('offer')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div className="min-h-screen bg-[#FFFBF0] font-sans text-gray-900 overflow-x-hidden" data-id="element-628">
      {/* Header - No animation */}
      <header className="sticky top-0 z-50 bg-white/90 backdrop-blur-md border-b border-gray-200 py-3 px-4 shadow-sm" data-id="element-629">
        <div className="max-w-6xl mx-auto flex justify-center items-center" data-id="element-630">
          <div className="font-black text-xl md:text-2xl tracking-tighter text-[#DC2626] flex items-center gap-2" data-id="element-631">
            <Flame className="w-6 h-6 fill-current" data-id="element-632" />
            SABOR CALLEJERO
          </div>
        </div>
      </header>

      {/* HERO - Keep essential animation */}
      <section className="relative bg-[#1F1F1F] text-white pt-12 pb-20 px-4 overflow-hidden" data-id="element-633">
        <div className="absolute top-0 right-0 w-64 h-64 bg-red-600/20 rounded-full blur-2xl -translate-y-1/2 translate-x-1/2" data-id="element-634"></div>
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-orange-500/10 rounded-full blur-2xl translate-y-1/2 -translate-x-1/2" data-id="element-635"></div>

        <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-12 items-center relative z-10" data-id="element-636">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.4
        }} className="space-y-6" data-id="element-637">
            <div className="inline-block bg-red-600/20 text-red-400 font-bold px-4 py-1.5 rounded-full text-sm border border-red-600/30" data-id="element-638">
              MÉTODO COMPROBADO
            </div>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-black leading-tight tracking-tight" data-id="element-639">
              De 0 a tus primeros pedidos en{' '}
              <span className="text-[#DC2626]" data-id="element-640">30 días</span> (sin volverte
              loco)
            </h1>
            <p className="text-lg md:text-xl text-gray-300 leading-relaxed" data-id="element-641">
              Si tu sueldo no alcanza, esto es un plan... no un PDF más. No
              necesitas 350 recetas: necesitas un sistema que te diga qué
              vender, cómo producir y cómo cobrar.
            </p>
          </motion.div>

          <div className="relative" data-id="element-642">
            <div className="absolute inset-0 bg-gradient-to-tr from-red-600/20 to-transparent rounded-3xl transform rotate-3" data-id="element-643"></div>
            <img src="https://cdn.magicpatterns.com/uploads/31vKrbNU8aAgPVZWT6WBty/Mock_up.png" alt="Sabor Callejero Ebook en Tablet" loading="eager" width="400" height="400" className="relative z-10 w-full max-w-md mx-auto drop-shadow-2xl transform -rotate-2" data-id="element-644" />
            <div className="mt-8 flex flex-col items-center gap-4" data-id="element-645">
              <button onClick={scrollToOffer} className="bg-[#DC2626] hover:bg-red-700 text-white font-bold py-3 px-6 rounded-xl text-base transition-colors shadow-xl shadow-red-900/30 flex items-center justify-center gap-2 whitespace-nowrap" data-id="element-646">
                QUIERO MI MENÚ DE COMBOS
                <ArrowRight className="w-5 h-5" data-id="element-647" />
              </button>
              <div className="flex items-center gap-2 text-sm text-gray-400" data-id="element-648">
                <div className="flex -space-x-2" data-id="element-649">
                  {[1, 2, 3, 4].map(i => <div key={i} className="w-8 h-8 rounded-full bg-gray-700 border-2 border-[#1F1F1F] flex items-center justify-center text-xs" data-id="element-650">
                      <Star className="w-3 h-3 text-yellow-500 fill-current" data-id="element-651" />
                    </div>)}
                </div>
                <p data-id="element-652">Más de 500 emprendedores ya empezaron</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* PAIN AGITATION - No animations */}
      <section className="py-20 px-4 bg-white" data-id="element-653">
        <div className="max-w-4xl mx-auto" data-id="element-654">
          <div className="text-center mb-12" data-id="element-655">
            <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-4" data-id="element-656">
              El problema real: estás intentando "adivinar"
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-657">
              Esa incertidumbre te drena más que la cocina. La mayoría empieza
              mal porque quiere vender "comida" sin estrategia.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 items-center" data-id="element-658">
            <div className="space-y-4" data-id="element-659">
              {['¿Qué receta vendo hoy?', '¿Cuánto cobro para no perder?', '¿Y si no me queda ganancia?', '¿Cómo entrego sin perder el día?'].map((pain, idx) => <div key={idx} className="flex items-start gap-4 p-4 bg-red-50 rounded-xl border border-red-100" data-id="element-660">
                  <div className="bg-red-100 p-2 rounded-full shrink-0" data-id="element-661">
                    <X className="w-5 h-5 text-red-600" data-id="element-662" />
                  </div>
                  <p className="font-medium text-gray-800 pt-1" data-id="element-663">{pain}</p>
                </div>)}
            </div>

            <div className="bg-gray-900 text-white p-8 rounded-2xl shadow-xl relative overflow-hidden" data-id="element-664">
              <div className="absolute top-0 right-0 w-32 h-32 bg-red-600/20 rounded-full blur-xl" data-id="element-665"></div>
              <h3 className="text-2xl font-bold mb-4 relative z-10" data-id="element-666">
                La trampa de las "350 recetas"
              </h3>
              <p className="text-gray-300 mb-6 relative z-10" data-id="element-667">
                Tener un PDF con cientos de recetas solo causa parálisis.
                Terminas con 20 ingredientes abiertos, porciones al ojo y cero
                ganancia.
              </p>
              <div className="p-4 bg-white/10 rounded-xl border border-white/10 relative z-10" data-id="element-668">
                <p className="font-semibold text-red-300" data-id="element-669">
                  "No necesitas inspiración. Necesitas un sistema."
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* UNIQUE MECHANISM - No animations */}
      <section className="py-20 px-4 bg-[#1F1F1F] text-white overflow-hidden" data-id="element-670">
        <div className="max-w-5xl mx-auto" data-id="element-671">
          <div className="text-center mb-16" data-id="element-672">
            <span className="text-[#DC2626] font-bold tracking-wider uppercase text-sm" data-id="element-673">
              La Solución
            </span>
            <h2 className="text-3xl md:text-5xl font-black mt-2 mb-6" data-id="element-674">
              Sistema Combo-Listo™
            </h2>
            <p className="text-xl text-gray-400 max-w-3xl mx-auto" data-id="element-675">
              En lugar de recetas sueltas, usamos una fórmula que convierte
              cocina casera en un menú tipo cadena.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-4 relative" data-id="element-676">
            <div className="hidden md:block absolute top-1/2 left-0 w-full h-1 bg-gray-700 -translate-y-1/2 z-0" data-id="element-677"></div>
            {[{
            icon: ChefHat,
            title: 'Proteína Callejera',
            desc: 'Lo que llena',
            color: 'bg-orange-500'
          }, {
            icon: Droplet,
            title: 'Salsa Firma',
            desc: 'Lo que engancha',
            color: 'bg-red-600'
          }, {
            icon: Utensils,
            title: 'Acompañamiento',
            desc: 'Sube valor percibido',
            color: 'bg-yellow-500'
          }, {
            icon: CupSoda,
            title: 'Bebida',
            desc: 'Aumenta ticket',
            color: 'bg-blue-500'
          }].map((item, idx) => <div key={idx} className="relative z-10 bg-gray-800 border border-gray-700 p-6 rounded-2xl text-center shadow-xl" data-id="element-678">
                <div className={`w-16 h-16 ${item.color} rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg`} data-id="element-679">
                  <item.icon className="w-8 h-8 text-white" data-id="element-680" />
                </div>
                <h3 className="font-bold text-lg mb-1" data-id="element-681">{item.title}</h3>
                <p className="text-gray-400 text-sm" data-id="element-682">{item.desc}</p>
                {idx < 3 && <div className="md:hidden absolute -bottom-6 left-1/2 -translate-x-1/2 text-gray-600 font-bold text-xl" data-id="element-683">
                    +
                  </div>}
              </div>)}
          </div>

          <div className="mt-12 text-center bg-gray-800/50 p-6 rounded-2xl border border-gray-700" data-id="element-684">
            <p className="text-xl font-medium" data-id="element-685">
              = <span className="text-[#DC2626] font-bold" data-id="element-686">10 combos</span> que
              la gente entiende, elige rápido y repite.
            </p>
          </div>
        </div>
      </section>

      {/* TRANSFORMATION - No animations */}
      <section className="py-20 px-4 bg-[#FFFBF0]" data-id="element-687">
        <div className="max-w-5xl mx-auto" data-id="element-688">
          <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-689">
            <div data-id="element-690">
              <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-6" data-id="element-691">
                ¿Qué cambia cuando vendes combos?
              </h2>
              <div className="space-y-6" data-id="element-692">
                {[{
                title: 'Pedidos Claros',
                desc: "Tus clientes dicen 'dame el Combo #3' sin mil preguntas."
              }, {
                title: 'Producción por Tandas',
                desc: 'Cocinas componentes en bloque, no plato por plato. Adiós caos.'
              }, {
                title: 'Compras Exactas',
                desc: 'Sabes exactamente qué comprar. Cero desperdicio de ingredientes.'
              }, {
                title: 'Imagen Profesional',
                desc: 'Tu menú se ve como una cadena real, aunque cocines en casa.'
              }, {
                title: 'Ticket Alto',
                desc: 'Vendes menú completo, no solo un plato suelto. Ganas más por pedido.'
              }].map((benefit, idx) => <div key={idx} className="flex gap-4" data-id="element-693">
                    <div className="bg-green-100 p-2 rounded-full h-fit shrink-0" data-id="element-694">
                      <Check className="w-5 h-5 text-green-600" data-id="element-695" />
                    </div>
                    <div data-id="element-696">
                      <h4 className="font-bold text-gray-900" data-id="element-697">
                        {benefit.title}
                      </h4>
                      <p className="text-gray-600 text-sm" data-id="element-698">{benefit.desc}</p>
                    </div>
                  </div>)}
              </div>
            </div>

            <div className="bg-white p-8 rounded-3xl shadow-2xl border border-gray-100" data-id="element-699">
              <div className="space-y-4" data-id="element-700">
                <div className="flex items-center gap-3 border-b pb-4" data-id="element-701">
                  <div className="w-10 h-10 bg-green-500 rounded-full flex items-center justify-center text-white font-bold text-sm" data-id="element-702">
                    MC
                  </div>
                  <div data-id="element-703">
                    <p className="font-semibold text-gray-900" data-id="element-704">María Carmen</p>
                    <p className="text-xs text-gray-500" data-id="element-705">Cliente satisfecha</p>
                  </div>
                </div>
                <div className="space-y-3" data-id="element-706">
                  <div className="bg-gray-100 p-3 rounded-tr-2xl rounded-bl-2xl rounded-br-2xl max-w-[80%]" data-id="element-707">
                    <p className="text-sm text-gray-600" data-id="element-708">
                      Hola, ¿qué precio tiene el pollo?
                    </p>
                  </div>
                  <div className="bg-red-50 p-3 rounded-tl-2xl rounded-bl-2xl rounded-br-2xl max-w-[90%] ml-auto border border-red-100" data-id="element-709">
                    <p className="text-sm text-gray-800 font-medium" data-id="element-710">
                      ¡Hola! Te recomiendo el{' '}
                      <span className="text-red-600 font-bold" data-id="element-711">
                        Combo #2 (Pollo Crispy)
                      </span>
                      . Incluye papas, salsa de la casa y bebida por $8.50
                      🍗🍟🥤
                    </p>
                  </div>
                  <div className="bg-gray-100 p-3 rounded-tr-2xl rounded-bl-2xl rounded-br-2xl max-w-[80%]" data-id="element-712">
                    <p className="text-sm text-gray-600" data-id="element-713">
                      ¡Uff se ve buenísimo! Dame 2 combos por favor.
                    </p>
                  </div>
                </div>
                <div className="mt-4 pt-4 border-t text-center" data-id="element-714">
                  <p className="text-xs text-gray-400 uppercase tracking-widest" data-id="element-715">
                    Venta cerrada en 2 mensajes
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* WHAT'S INCLUDED - No animations */}
      <section className="py-20 px-4 bg-white" data-id="element-716">
        <div className="max-w-6xl mx-auto" data-id="element-717">
          <div className="text-center mb-16" data-id="element-718">
            <h2 className="text-3xl md:text-5xl font-black text-gray-900 mb-4" data-id="element-719">
              Lo que incluye{' '}
              <span className="text-[#DC2626]" data-id="element-720">Sabor Callejero</span>
            </h2>
            <p className="text-xl text-gray-600" data-id="element-721">
              Todo lo que necesitas para arrancar en 30 días
            </p>
          </div>

          <div className="bg-gray-900 text-white rounded-3xl p-8 md:p-12 relative overflow-hidden shadow-2xl" data-id="element-722">
            <div className="absolute top-0 right-0 w-64 h-64 bg-red-600/20 rounded-full blur-2xl" data-id="element-723"></div>
            <div className="relative z-10" data-id="element-724">
              <div className="flex items-center gap-3 mb-6" data-id="element-725">
                <div className="bg-[#DC2626] p-2 rounded-lg" data-id="element-726">
                  <ShoppingBag className="w-6 h-6 text-white" data-id="element-727" />
                </div>
                <h3 className="text-2xl font-bold" data-id="element-728">
                  Ebook Principal (Plan Completo)
                </h3>
              </div>
              <div className="grid md:grid-cols-2 gap-6" data-id="element-729">
                <ul className="space-y-4" data-id="element-730">
                  {['Menú corto listo (10 combos base)', '3 salsas firma con variantes', 'Producción por tandas (batching)', 'Costeo fácil para proteger tu margen'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-731">
                      <Check className="w-5 h-5 text-[#DC2626] shrink-0 mt-0.5" data-id="element-732" />
                      <span className="text-gray-300" data-id="element-733">{item}</span>
                    </li>)}
                </ul>
                <ul className="space-y-4" data-id="element-734">
                  {['Presentación tipo cadena (empaque, fotos)', 'Operación sin caos: pedidos y horarios', 'Plan de 30 días (día por día)', 'Guía de lanzamiento rápido'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-735">
                      <Check className="w-5 h-5 text-[#DC2626] shrink-0 mt-0.5" data-id="element-736" />
                      <span className="text-gray-300" data-id="element-737">{item}</span>
                    </li>)}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* WHO IT'S FOR - No animations */}
      <section className="py-20 px-4 bg-gray-50" data-id="element-738">
        <div className="max-w-4xl mx-auto" data-id="element-739">
          <h2 className="text-3xl font-black text-center mb-12" data-id="element-740">
            ¿Es para ti?
          </h2>
          <div className="grid md:grid-cols-2 gap-8" data-id="element-741">
            <div className="bg-white p-8 rounded-3xl shadow-lg border-t-4 border-green-500" data-id="element-742">
              <h3 className="text-xl font-bold text-green-700 mb-6 flex items-center gap-2" data-id="element-743">
                <Check className="w-6 h-6" data-id="element-744" /> ESTO ES PARA TI SI...
              </h3>
              <ul className="space-y-4" data-id="element-745">
                {['Necesitas ingreso extra real y quieres arrancar sin caos', 'Eres principiante y quieres un paso a paso exacto', 'Estás cansado de PDFs lindos que no venden nada', 'Quieres vender por encargo y controlar tu tiempo'].map((item, i) => <li key={i} className="flex items-start gap-3 text-gray-700" data-id="element-746">
                    <Check className="w-5 h-5 text-green-500 shrink-0 mt-0.5" data-id="element-747" />
                    {item}
                  </li>)}
              </ul>
            </div>

            <div className="bg-white p-8 rounded-3xl shadow-lg border-t-4 border-red-500" data-id="element-748">
              <h3 className="text-xl font-bold text-red-700 mb-6 flex items-center gap-2" data-id="element-749">
                <X className="w-6 h-6" data-id="element-750" /> NO ES PARA TI SI...
              </h3>
              <ul className="space-y-4" data-id="element-751">
                {['Buscas resultados mágicos sin cocinar ni trabajar', 'Quieres abrir un restaurante completo mañana mismo', 'No estás dispuesto a seguir un plan paso a paso', 'Crees que ya lo sabes todo sobre ventas'].map((item, i) => <li key={i} className="flex items-start gap-3 text-gray-700" data-id="element-752">
                    <X className="w-5 h-5 text-red-500 shrink-0 mt-0.5" data-id="element-753" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* OFFER SECTION - Keep animation for impact */}
      <section id="offer" className="py-24 px-4 bg-[#1F1F1F] text-white relative overflow-hidden" data-id="element-754">
        <div className="max-w-3xl mx-auto relative z-10" data-id="element-755">
          <motion.div initial={{
          scale: 0.95,
          opacity: 0
        }} whileInView={{
          scale: 1,
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3
        }} className="bg-white text-gray-900 rounded-3xl p-8 md:p-12 shadow-2xl text-center border-4 border-[#DC2626]" data-id="element-756">
            <div className="inline-block bg-yellow-400 text-yellow-900 font-bold px-4 py-1 rounded-full text-sm mb-6 uppercase tracking-wider" data-id="element-757">
              Oferta Especial
            </div>
            <h2 className="text-3xl md:text-4xl font-black mb-2" data-id="element-758">
              Sabor Callejero
            </h2>
            <p className="text-xl text-gray-600 mb-8" data-id="element-759">
              Menú Viral de Combos (30 días)
            </p>
            <div className="flex items-center justify-center gap-4 mb-8" data-id="element-760">
              <span className="text-gray-400 text-2xl line-through decoration-red-500 decoration-2" data-id="element-761">
                $47
              </span>
              <span className="text-6xl md:text-7xl font-black text-[#DC2626]" data-id="element-762">
                $6.39
              </span>
            </div>
            <div className="space-y-4 mb-10 text-left max-w-md mx-auto bg-gray-50 p-6 rounded-xl" data-id="element-763">
              {['Acceso inmediato (100% Digital)', 'Todos los bonos incluidos', 'Plan paso a paso de 30 días'].map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-764">
                  <div className="bg-green-100 p-1 rounded-full" data-id="element-765">
                    <Check className="w-4 h-4 text-green-600" data-id="element-766" />
                  </div>
                  <span className="font-medium" data-id="element-767">{item}</span>
                </div>)}
            </div>
            <a href="https://oriammarketing.com/cart/45497923403974:1" target="_blank" rel="noopener noreferrer" onClick={handleAddToCart} className="w-full bg-[#DC2626] hover:bg-red-700 text-white font-black text-xl md:text-2xl py-6 px-8 rounded-xl shadow-xl transition-colors mb-6 flex items-center justify-center gap-3" data-id="element-768">
              QUIERO EMPEZAR HOY
              <ArrowRight className="w-6 h-6" data-id="element-769" />
            </a>
            <div className="flex items-center justify-center gap-2 text-sm text-gray-500" data-id="element-770">
              <ShieldCheck className="w-5 h-5 text-green-500" data-id="element-771" />
              <p data-id="element-772">
                Garantía de 7 días: si no es para ti, te devolvemos tu dinero.
              </p>
            </div>
          </motion.div>
        </div>
      </section>

      {/* FINAL CTA */}
      <section className="py-20 px-4 bg-white text-center" data-id="element-773">
        <div className="max-w-2xl mx-auto" data-id="element-774">
          <h2 className="text-3xl font-bold mb-6" data-id="element-775">
            En los próximos 30 días vas a tener algo que hoy te falta:
          </h2>
          <p className="text-xl text-gray-600 mb-8" data-id="element-776">
            Un sistema claro que convierte tu cocina en pedidos reales.
          </p>
          <button onClick={scrollToOffer} className="inline-flex items-center gap-2 text-[#DC2626] font-bold text-lg hover:underline underline-offset-4" data-id="element-777">
            Ir a la oferta <ArrowRight className="w-5 h-5" data-id="element-778" />
          </button>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-gray-400 py-12 px-4" data-id="element-779">
        <div className="max-w-4xl mx-auto" data-id="element-780">
          <div className="flex flex-col md:flex-row justify-center items-center gap-6 mb-8" data-id="element-781">
            <button onClick={() => setShowPrivacy(true)} className="hover:text-white transition-colors" data-id="element-782">
              Política de Privacidad
            </button>
            <span className="hidden md:inline text-gray-600" data-id="element-783">|</span>
            <button onClick={() => setShowTerms(true)} className="hover:text-white transition-colors" data-id="element-784">
              Términos y Condiciones
            </button>
          </div>
          <div className="text-center text-sm" data-id="element-785">
            <p data-id="element-786">
              © {new Date().getFullYear()} Sabor Callejero. Todos los derechos
              reservados.
            </p>
            <p className="mt-2 text-gray-500" data-id="element-787">
              Este producto no garantiza resultados económicos. El éxito depende
              de tu implementación.
            </p>
          </div>
        </div>
      </footer>

      {/* Modals - Lazy rendered */}
      <AnimatePresence data-id="element-788">
        {showPrivacy && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 bg-black/70 backdrop-blur-sm z-50 flex items-center justify-center p-4" onClick={() => setShowPrivacy(false)} data-id="element-789">
            <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: 20
        }} className="bg-white rounded-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-790">
              <div className="sticky top-0 bg-white border-b border-gray-100 p-6 flex items-center justify-between" data-id="element-791">
                <h3 className="text-xl font-bold text-gray-900" data-id="element-792">
                  Política de Privacidad
                </h3>
                <button onClick={() => setShowPrivacy(false)} className="p-2 hover:bg-gray-100 rounded-full transition-colors" data-id="element-793">
                  <X className="w-5 h-5 text-gray-500" data-id="element-794" />
                </button>
              </div>
              <div className="p-6 space-y-4 text-gray-600 text-sm leading-relaxed" data-id="element-795">
                <p data-id="element-796">
                  Esta política describe cómo recopilamos, usamos y protegemos
                  la información cuando utilizas nuestros servicios digitales.
                </p>
                <p data-id="element-797">
                  <strong className="text-gray-800" data-id="element-798">
                    Información recopilada:
                  </strong>{' '}
                  Podemos recopilar datos como nombre, correo electrónico y
                  datos de pago cuando realizas una compra.
                </p>
                <p data-id="element-799">
                  <strong className="text-gray-800" data-id="element-800">Uso de cookies:</strong>{' '}
                  Utilizamos cookies para mejorar tu experiencia de navegación y
                  analizar el tráfico del sitio.
                </p>
                <p data-id="element-801">
                  <strong className="text-gray-800" data-id="element-802">
                    Protección de datos:
                  </strong>{' '}
                  Implementamos medidas de seguridad para proteger tu
                  información personal.
                </p>
                <p data-id="element-803">
                  <strong className="text-gray-800" data-id="element-804">Tus derechos:</strong>{' '}
                  Tienes derecho a acceder, rectificar o eliminar tus datos
                  personales.
                </p>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>

      <AnimatePresence data-id="element-805">
        {showTerms && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 bg-black/70 backdrop-blur-sm z-50 flex items-center justify-center p-4" onClick={() => setShowTerms(false)} data-id="element-806">
            <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: 20
        }} className="bg-white rounded-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-807">
              <div className="sticky top-0 bg-white border-b border-gray-100 p-6 flex items-center justify-between" data-id="element-808">
                <h3 className="text-xl font-bold text-gray-900" data-id="element-809">
                  Términos y Condiciones
                </h3>
                <button onClick={() => setShowTerms(false)} className="p-2 hover:bg-gray-100 rounded-full transition-colors" data-id="element-810">
                  <X className="w-5 h-5 text-gray-500" data-id="element-811" />
                </button>
              </div>
              <div className="p-6 space-y-4 text-gray-600 text-sm leading-relaxed" data-id="element-812">
                <p data-id="element-813">
                  Al adquirir este producto digital, aceptas los siguientes
                  términos y condiciones de uso.
                </p>
                <p data-id="element-814">
                  <strong className="text-gray-800" data-id="element-815">Producto digital:</strong>{' '}
                  Este es un producto 100% digital. Una vez completada la
                  compra, recibirás acceso inmediato al contenido.
                </p>
                <p data-id="element-816">
                  <strong className="text-gray-800" data-id="element-817">Licencia de uso:</strong> La
                  compra te otorga una licencia personal e intransferible.
                </p>
                <p data-id="element-818">
                  <strong className="text-gray-800" data-id="element-819">
                    Garantía de devolución:
                  </strong>{' '}
                  Ofrecemos una garantía de 7 días.
                </p>
                <p data-id="element-820">
                  <strong className="text-gray-800" data-id="element-821">Resultados:</strong> Los
                  resultados pueden variar según la implementación individual.
                </p>
                <p data-id="element-822">
                  <strong className="text-gray-800" data-id="element-823">
                    Propiedad intelectual:
                  </strong>{' '}
                  Todo el contenido está protegido por derechos de autor.
                </p>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}